<template>
    <MenuBase :hidden="props.hidden" 
        :tooltipPosition="props.tooltipPosition" :theme="props.theme" 
        :tooltipText="chordsStore.state.visible ? 'Hide chords' : 'Show chords'"
        :active="chordsStore.state.visible"
        @menuClick="toggleChords()">
        <EyeIcon v-if="chordsStore.state.visible" class="size-6" />
        <EyeSlashIcon v-else class="size-6" />
    </MenuBase>
</template>
<script setup>
import { defineProps} from 'vue'
import { EyeIcon, EyeSlashIcon } from '@heroicons/vue/24/outline';
import MenuBase from '@/components/common/menus/MenuBase.vue';
import { appEvents } from '@/store/app.events';
import chordsStore from '@/store/chords.store';

const props = defineProps( {
    disabled: {
        type: Boolean,
        default: true
    },
    hidden: {
        type: Boolean,
        default: true
    },
    tooltipPosition: {
        type: String,
        default: 'top'
    },
    active: {
        type: Boolean,
        default: true
    },
    theme: {
        type: String,
        default: 'light'
    },
    tooltipText: {
        type: String,
        default: 'Show chords'
    }
})

const toggleChords = () => {
    chordsStore.state.visible = !chordsStore.state.visible;
    appEvents.emit('currentChordsVisibility', chordsStore.state.visible);
}

appEvents.on('toggleChords', (value) => {
    chordsStore.state.visible = value;
});
appEvents.on('currentChordsVisibility', (value) => {
    chordsStore.state.visible = value;
});
</script>